export default __webpack_public_path__ + "static/media/data-leakage.269de881.svg";